module.exports = __webpack_public_path__ + "static/img/texture.813b763.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/texture.png
// module id = 0hYH
// module chunks = 0